import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { TextField } from '~common/components/form/field-text.component';
import {
  TranslationField,
  TranslationFormData,
} from '~admin/view/components/ui/form/fields/field-translation.component';
import { Box } from '~common/components/box.component';
import { Color } from '~common/model/basics';
import { DeleteIcon } from '~web/view/components/ui/icon/delete.icon';
import { Column } from '~common/components/column.component';
import { AccessibilityType } from '~client/model/accessibility-type';
import { NumberField } from '~admin/view/components/ui/form/fields/field-number.component';
import { SelectField } from '~admin/view/components/ui/form/fields/field-select.component';
import { optionEnumeratorMapper } from '~common/components/select.helper';

interface Props {
  name: string;
  onRemove?: () => void;
}

export interface SeatConfigurationCategoryItemFormData {
  name: TranslationFormData<string>[];
  accessibilityType: AccessibilityType;
  yoopCount: number;
  categoryDetail?: TranslationFormData<string>[];
  emailRules?: TranslationFormData<string>[];
  rules?: TranslationFormData<string>[];
  externalTaxCode?: string;
  minimumUserAge?: number;
}

export const SeatConfigurationCategoryItemFields: React.FunctionComponent<Props> = ({
  name,
  onRemove,
}) => {
  const { t } = useTranslation();
  return (
    <Container>
      <RestrictBox>
        <TranslationField
          name={`${name}.name`}
          label={t('createEvent.seatConfiguration.category.name')}
          render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
        />
      </RestrictBox>
      <Box>
        <RestrictBox>
          <SelectField
            name={`${name}.accessibilityType`}
            label={t('createEvent.seatConfiguration.category.accessibilityType')}
            options={optionEnumeratorMapper(
              AccessibilityType,
              t,
              'createEvent.eventDetails.options.accessibilityType.enum',
            )}
          />
        </RestrictBox>
        <RestrictBox>
          <NumberField
            name={`${name}.yoopCount`}
            label={t('createEvent.seatConfiguration.category.yoopCount')}
          />
        </RestrictBox>
      </Box>
      <Box>
        <RestrictBox>
          <NumberField
            name={`${name}.minimumUserAge`}
            label={t('createEvent.seatConfiguration.category.minimumUserAge')}
          />
        </RestrictBox>
        <RestrictBox>
          <TextField
            name={`${name}.externalTaxCode`}
            label={t('createEvent.seatConfiguration.category.externalTaxCode')}
          />
        </RestrictBox>
      </Box>
      <RestrictBox>
        <TranslationField
          name={`${name}.categoryDetail`}
          label={t('createEvent.seatConfiguration.category.details')}
          render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
        />
      </RestrictBox>
      <RestrictBox>
        <TranslationField
          name={`${name}.rules`}
          label={t('createEvent.seatConfiguration.category.rules')}
          render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
        />
      </RestrictBox>
      <RestrictBox>
        <TranslationField
          name={`${name}.emailRules`}
          label={t('createEvent.seatConfiguration.category.emailRules')}
          render={(renderProps): ReactNode => <TextField multiline {...renderProps} />}
        />
      </RestrictBox>
      <IconBox>
        <DeleteIcon
          color={Color.White}
          onClick={(): void => {
            onRemove?.();
          }}
        />
      </IconBox>
    </Container>
  );
};

const Container = styled(Column)`
  flex: 1 1 auto;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  padding: 16px;
  margin: 12px 0;
`;

const RestrictBox = styled(Column)`
  flex: 1 1 auto;
  margin: 0 12px;

  > div:not(:first-child) {
    margin-top: 16px;
  }
`;

const IconBox = styled(Box)`
  flex: 0.1 0.1 auto;
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./view/components/details/event-details/event-location-details/seat-configuration-category-item-fields.component.tsx